import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { RefreshCw } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable } from 'react-native';

export const BiRetry = memo(
  ({
    label = '暂时无法加载，点击重试',
    onRetry,
  }: {
    label?: string;
    onRetry: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        accessibilityRole="button"
        onPress={onRetry}
        style={{ flexDirection: 'row', gap: rpx(8), alignItems: 'center' }}
      >
        <RefreshCw size={16} color={aiColors.mutedForeground} />
        <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
          {label}
        </Typography.Text>
      </Pressable>
    );
  },
);
